const loadRazorpay = () =>
    new Promise((resolve, reject) => {
        if (window.Razorpay) {
            resolve(window.Razorpay);
            return;
        }
        const existing = document.querySelector("script[data-razorpay-checkout]");
        if (existing) {
            existing.addEventListener("load", () => resolve(window.Razorpay));
            existing.addEventListener("error", () => reject(new Error("Could not load the payment window")));
            return;
        }
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        script.dataset.razorpayCheckout = "true";
        script.onload = () => resolve(window.Razorpay);
        script.onerror = () => reject(new Error("Could not load the payment window"));
        document.body.appendChild(script);
    });

const firstValue = (source, keys) => {
    for (const key of keys) {
        if (source?.[key]) return source[key];
    }
    return "";
};

export const readCheckoutFields = (payment) => {
    const source = payment?.data && typeof payment.data === "object" ? { ...payment, ...payment.data } : payment || {};
    return {
        key: firstValue(source, ["key", "razorpay_key", "key_id", "razorpayKey"])
            || process.env.REACT_APP_RAZORPAY_KEY_ID
            || "",
        orderId: firstValue(source, ["order_id", "razorpay_order_id", "payment_gateway_id", "id"]),
        currency: source.currency || "INR",
    };
};

export const openRazorpayCheckout = async ({ key, orderId, currency, description, name, email }) => {
    if (!key || !orderId) {
        throw new Error("Payment could not be started. The server did not return a checkout order.");
    }
    const Razorpay = await loadRazorpay();
    return new Promise((resolve, reject) => {
        const checkout = new Razorpay({
            key,
            order_id: orderId,
            currency: currency || "INR",
            name: "Virtual Prachar",
            description: description || "Credit top-up",
            prefill: { name: name || "", email: email || "" },
            handler: (response) => resolve({
                paymentId: response?.razorpay_payment_id,
                orderId: response?.razorpay_order_id || orderId,
                signature: response?.razorpay_signature,
            }),
            modal: {
                ondismiss: () => reject(new Error("Payment was cancelled")),
            },
        });
        checkout.on("payment.failed", (response) => {
            reject(new Error(response?.error?.description || "Payment failed"));
        });
        checkout.open();
    });
};
